/**
 * Parses the URL search parameters and retrieves the landing page brand information.
 * @returns Returns the brand associated with the landing page if found, otherwise an empty string.
 */
const searchParams = new URLSearchParams(window.location.search);
/**
 * Retrieves the landing page brand based on the landingId parameter in the URL.
 * @returns Returns the brand associated with the landing page if found, otherwise an empty string.
 */
export const getLandingPageBrand = () => {
    var _a;
    const landingId = (_a = searchParams.get("landingId")) !== null && _a !== void 0 ? _a : "";
    if (landingId !== "") {
        const landing = JSON.parse(localStorage.getItem(landingId));
        if (landing !== null) {
            return landing.renter;
        }
        else {
            return "";
        }
    }
};
